import { isBreakpoint, onLoadAndResize } from "../utils";

const SELECTORS = {
  columnItem: ".global-footer__link-item",
  iconItem: ".global-footer__link-text__icon",
  textItem: ".global-footer__link-text__content",
};

class FooterColumn {
  constructor(context) {
    this.context = context;
    this.columnLinks = null;
    this.columnText = null;
    this.columnIcon = null;
    this.leftDistance = 0;
  }

  init() {
    this.columnLinks = [...this.context.querySelectorAll(SELECTORS.columnItem)];
    this.subscribe();
  }

  subscribe() {
    this.columnLinks.forEach((link) => {
      window.addEventListener("load", () => {
        onLoadAndResize(() => {
          this.columnText = link.querySelector(SELECTORS.textItem);
          this.columnIcon = link.querySelector(SELECTORS.iconItem);

          this.handleDistance(this.columnText, this.columnIcon);
        }).apply();
      });
    });
  }

  handleDistance(text, icon) {
    const columnIcon = icon;
    const columnText = text;

    this.leftDistance = `${columnText.offsetWidth + 20}px`;
    columnIcon.style.left = this.leftDistance;
  }
}

export { FooterColumn };
